/* global translations */
import React from 'react';
import get from 'lodash/get';
import { ImageSvg } from '../image';

const ExtendedFormSubmitError = () => (
  <div className="message mtm">
    <div className="flash-inner error dib pr">
      <div className="flash-icon">
        <ImageSvg svg="icon-warning" iconClass="icon--full icon--warning" />
      </div>
      <div className="flash-content mls">
        {get(translations, 'txt: Nezināma kļūda', 'txt: Nezināma kļūda')}
      </div>
    </div>
  </div>
);

export default ExtendedFormSubmitError;
